import {
  PLAN_PLAN_LNG_MODAL_CHANGE,
} from './constants';

export function plan_lngModalChange(visible,type) {
  return {
    type: PLAN_PLAN_LNG_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLAN_PLAN_LNG_MODAL_CHANGE:
      return {
        ...state,
        plan_lngModalType:action.data.type,
        plan_lngModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/plan/redux/plan_lngModalChange.js